var _g, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVs = function SvgVs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3225_8141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7146 7.28539C20.1859 3.81406 25.8141 3.81407 29.2854 7.28539L36.7146 14.7146C40.1859 18.1859 40.1859 23.8141 36.7146 27.2854L29.2854 34.7146C25.8141 38.1859 20.1859 38.1859 16.7146 34.7146L9.28539 27.2854C5.81406 23.8141 5.81407 18.1859 9.28539 14.7146L16.7146 7.28539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0711 6.49972C26.1658 2.59448 19.8342 2.59447 15.9289 6.49971L8.49972 13.9289C4.59448 17.8342 4.59447 24.1658 8.49971 28.0711L15.9289 35.5003C19.8342 39.4055 26.1658 39.4055 30.0711 35.5003L37.5003 28.0711C41.4055 24.1658 41.4055 17.8342 37.5003 13.9289L30.0711 6.49972Z",
    stroke: "white",
    strokeWidth: 2.22222
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3672 23.1426L21.5352 16.4688H23.1641L20.0938 25H18.6582L15.5996 16.4688H17.2227L19.3672 23.1426ZM28.5898 22.8027C28.5898 22.4277 28.457 22.1387 28.1914 21.9355C27.9297 21.7324 27.4551 21.5273 26.7676 21.3203C26.0801 21.1133 25.5332 20.8828 25.127 20.6289C24.3496 20.1406 23.9609 19.5039 23.9609 18.7188C23.9609 18.0312 24.2402 17.4648 24.7988 17.0195C25.3613 16.5742 26.0898 16.3516 26.9844 16.3516C27.5781 16.3516 28.1074 16.4609 28.5723 16.6797C29.0371 16.8984 29.4023 17.2109 29.668 17.6172C29.9336 18.0195 30.0664 18.4668 30.0664 18.959H28.5898C28.5898 18.5137 28.4492 18.166 28.168 17.916C27.8906 17.6621 27.4922 17.5352 26.9727 17.5352C26.4883 17.5352 26.1113 17.6387 25.8418 17.8457C25.5762 18.0527 25.4434 18.3418 25.4434 18.7129C25.4434 19.0254 25.5879 19.2871 25.877 19.498C26.166 19.7051 26.6426 19.9082 27.3066 20.1074C27.9707 20.3027 28.5039 20.5273 28.9062 20.7812C29.3086 21.0312 29.6035 21.3203 29.791 21.6484C29.9785 21.9727 30.0723 22.3535 30.0723 22.791C30.0723 23.502 29.7988 24.0684 29.252 24.4902C28.709 24.9082 27.9707 25.1172 27.0371 25.1172C26.4199 25.1172 25.8516 25.0039 25.332 24.7773C24.8164 24.5469 24.4141 24.2305 24.125 23.8281C23.8398 23.4258 23.6973 22.957 23.6973 22.4219H25.1797C25.1797 22.9062 25.3398 23.2812 25.6602 23.5469C25.9805 23.8125 26.4395 23.9453 27.0371 23.9453C27.5527 23.9453 27.9395 23.8418 28.1973 23.6348C28.459 23.4238 28.5898 23.1465 28.5898 22.8027Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3225_8141",
    x: 0.458984,
    y: 0.460938,
    width: 45.082,
    height: 45.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.125848 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_8141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_8141",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vs.a1cd23e1.svg";
export { ForwardRef as ReactComponent };